export const NAVIGATION_NAME_ACTIVITY_BRANCHES = 'ActivityBranches';
export const NAVIGATION_NAME_ACTIVITY_COMMENTS = 'ActivityComments';
export const NAVIGATION_NAME_ACTIVITY_DETAIL = 'ActivityDetail';
export const NAVIGATION_NAME_ACTIVITY_DETAIL_PUSH = 'PushActivityDetail';
export const NAVIGATION_NAME_ACTIVITY_RATINGS = 'ActivityRatings';
export const NAVIGATION_NAME_ADD_BUSINESS_REQUEST = 'AddBusinessRequest';
export const NAVIGATION_NAME_AUTH = 'Auth';
export const NAVIGATION_NAME_BRANCHES = 'Branches';
export const NAVIGATION_NAME_BUSINESS_BRANCHES = 'BusinessBranches';
export const NAVIGATION_NAME_BUSINESS_GIFTS = 'BusinessGifts';
export const NAVIGATION_NAME_BUSINESS_GIFT_DETAILS = 'BusinessGiftDetails';
export const NAVIGATION_NAME_BUSINESS_OFFERS = 'BusinessOffers';
export const NAVIGATION_NAME_BUSINESS_POINTS_DETAILS = 'BusinessPointsDetails';
export const NAVIGATION_NAME_BUSINESS_POINTS_DETAILS_WITHOUT_TAB = 'BusinessPointsDetailsWOTab';
export const NAVIGATION_NAME_BUSINESS_PROFILE = 'BusinessProfile';
export const NAVIGATION_NAME_BUSINESS_REVIEWS = 'BusinessReviews';
export const NAVIGATION_NAME_BUSINESS_PROFILE_WITHOUT_TAB = 'BusinessProfileWOTab';
export const NAVIGATION_NAME_BUSINESS_SMART_ADS = 'BusinessSmartAds';
export const NAVIGATION_NAME_CATEGORY_TRANSACTIONS = 'CategoryTransactions';
export const NAVIGATION_NAME_CHANGE_PASSWORD = 'ChangePassword';
export const NAVIGATION_NAME_CHARITY_USERS = 'CharityUsers';
export const NAVIGATION_NAME_CONSUMED_OFFERS = 'ConsumedOffers';
export const NAVIGATION_NAME_CONVERSATIONS = 'Conversations';
export const NAVIGATION_NAME_DETAIL = 'Detail';
export const NAVIGATION_NAME_EDIT_PROFILE = 'EditProfile';
export const NAVIGATION_NAME_FAVOURITE_OFFERS = 'FavouriteOffers';
export const NAVIGATION_NAME_FUN = 'FunScreen';
export const NAVIGATION_NAME_GIFT_DETAIL = 'GiftDetail';
export const NAVIGATION_NAME_GIFT_ELIGIBLE = 'GiftEligible';
export const NAVIGATION_NAME_HELP = 'Help';
export const NAVIGATION_NAME_IMAGE = 'Image';
export const NAVIGATION_NAME_LAUNCH = 'Launch';
export const NAVIGATION_NAME_LOGIN = 'Login';
export const NAVIGATION_NAME_MAIN_TAB = 'Main';
export const NAVIGATION_NAME_MAP = 'Map';
export const NAVIGATION_NAME_MESSAGES = 'Messages';
export const NAVIGATION_NAME_MY_TRANSACTIONS = 'MyTransactions';
export const NAVIGATION_NAME_NOTIFICATIONS = 'Notifications';
export const NAVIGATION_NAME_OFFERS = 'Offers';
export const NAVIGATION_NAME_OFFERS_MAP = 'OffersMap';
export const NAVIGATION_NAME_PICK_FROM_MAP = 'PickFromMap';
export const NAVIGATION_NAME_POINTS = 'Points';
export const NAVIGATION_NAME_POST_DETAIL = 'PostDetail';
export const NAVIGATION_NAME_PUSH_ACTIVITY_COMMENTS = 'PushActivityComments';
export const NAVIGATION_NAME_PUSH_ADD_POST = 'PushAddPost';
export const NAVIGATION_NAME_PUSH_BUSINESS_POINTS_DETAILS = 'PushBusinessPointsDetails';
export const NAVIGATION_NAME_PUSH_MESSAGES = 'PushMessages';
export const NAVIGATION_NAME_PUSH_POST_DETAIL = 'PushPostDetail';
export const NAVIGATION_NAME_PROFILE_DETAILS = 'ProfileDetails';
export const NAVIGATION_NAME_RECOVER_PASSWORD = 'RecoverPassword';
export const NAVIGATION_NAME_REPORT_POST = 'ReportPost';
export const NAVIGATION_NAME_RESET_PASSWORD = 'ResetPassword';
export const NAVIGATION_NAME_REGISTER = 'Register';
export const NAVIGATION_NAME_SETTINGS = 'Settings';
export const NAVIGATION_NAME_SYSTEM_GIFTS = 'SystemGifts';
export const NAVIGATION_NAME_SYSTEM_GIFTS_WITHOUT_TAB = 'SystemGiftsWOTab';
export const NAVIGATION_NAME_SYSTEM_GIFT_WINNERS = 'GiftWinners';
export const NAVIGATION_NAME_SYSTEM_POINTS = 'SystemPoints';
export const NAVIGATION_NAME_TNC = 'Tnc';
export const NAVIGATION_NAME_TRANSACTIONS = 'Transactions';
export const NAVIGATION_NAME_TRANSACTIONS_FILTER = 'TransactionsFilter';
export const NAVIGATION_NAME_TRANSFER_MONEY = 'TransferMoney';
export const NAVIGATION_NAME_TRANSFER_POINTS = 'TransferPoints';
export const NAVIGATION_NAME_TRANSFER_OFFER = 'TransferOffer';
export const NAVIGATION_NAME_USER_PROFILE = 'UserProfileScreen';
export const NAVIGATION_NAME_USER_REQUEST_STATUS = 'UserRequestStatus';
export const NAVIGATION_NAME_VERIFY_LOGIN = 'VerifyLogin';

// export default class NavigationHelper {
//
//   static navigate(navigation, navigateName, params = null, key = Math.random().toString()) {
//     if (!params) {
//       params = {}
//     }
//     if (params.shouldBlockHeaderBack) {
//       params.headerLeft = ViewHelper.getNavigationLeft(() => {navigation.pop()}, IconCross);
//       params.gesturesEnabled = false;
//     } else {
//       params.headerLeft = ViewHelper.getNavigationBack(() => {navigation.pop()});
//       params.gesturesEnabled = !Utils.isAndroid();
//     }
//     params.headerTitleStyle = ViewHelper.headerTitleStyle;
//
//     navigation.navigate({
//       routeName: navigateName,
//       params: params,
//       key: key
//     });
//   }
//
//   static pop(navigation, count = 1) {
//     if (navigation) {
//       navigation.pop(count);
//     }
//   }
// }
